<div class="upgrader">
  <div class="upgrader__main">
    <div class="upgrader__panel upgrader__panel--left">
      <div class="upgrader__panel--content">
        @if (showBalanceInput()) {
          <button
            class="upgrader__close-balance-btn"
            (click)="toggleBalanceInput(); onUserInteraction()"
            [disabled]="upgraderService.isProcessing()"
          >
            <svg-icon
              class="flex items-center justify-center s-20 icon-gray"
              src="assets/icons/updater/close.svg"
              [applyClass]="true"
            />
          </button>
        }
        <svg-icon
          class="flex items-center justify-center target-panel__silhouette icon-empty"
          src="assets/icons/updater/empty.svg"
          [applyClass]="true"
        />
        <p class="upgrader__helper-text">Select an item you want to upgrade to</p>
        @if (showBalanceInput()) {
          <div class="upgrader__wager-form" @fadeInAnimation>
            <div class="upgrader__wager-input">
              <app-input-options
                [disabledInput]="upgraderService.isProcessing()"
                [disabledOptions]="upgraderService.isProcessing()"
                [(value)]="upgraderService.wagerAmount"
                [icon]="sessionService.balanceIconSrc()"
                [options]="betInputOptions"
                [placeholder]="sessionService.balanceType() + ' value'"
                [settings]="{
                optionType: 'square',
                maskSettings: {
                  mask: 'separator.2'
                }
              }"
              />
            </div>
            <div class="upgrader__wager-buttons">
              @for (item of betButtons; track item.label) {
                <button
                  class="button button--style-primary button--style-primary-bordered padding-x-8 rounded-4 h-32"
                  (click)="item.fn()"
                  [disabled]="upgraderService.isProcessing()"
                >
                  <app-balance-icon
                    [balance]="sessionService.balanceType()"
                    color="var(--yellow)"
                  />
                  {{ item.label }}
                </button>
              }
            </div>
          </div>
        }

        @if (!showBalanceInput()) {
          <button
            class="button button--style-yellow upgrader__action-btn"
            (click)="toggleBalanceInput(); onUserInteraction()"
            [disabled]="upgraderService.isProcessing()"
          >
            Use Balance
          </button>
        }
      </div>
    </div>

    <div class="upgrader__panel upgrader__panel--center">
      <app-upgrader-hexagon
        [chance]="upgraderService.baseChance()"
        [state]="upgraderService.state()"
        [roll]="upgraderService.lastRoll()"
        [won]="upgraderService.lastWon()"
        [winRangeStart]="upgraderService.winRangeStart()"
        [winRangeEnd]="upgraderService.winRangeEnd()"
        [isFastMode]="upgraderService.isFastMode()"
        [wonItemImage]="upgraderService.wonItemImage()"
        [wonAmount]="upgraderService.wonSkinsPrice()"
        [lostAmount]="upgraderService.lostAmount()"
        (animationComplete)="onAnimationComplete($event)"
      />
      @if (upgraderService.state() !== 'won') {
        <app-upgrader-offset-slider
          [offset]="upgraderService.offset()"
          [chance]="upgraderService.baseChance()"
          [disabled]="!upgraderService.isValid() || upgraderService.isProcessing()"
          (offsetChange)="upgraderService.setOffset($event); onUserInteraction()"
        />
      }
      @if (upgraderService.state() === 'won' && upgraderService.wonSkins().length > 0) {
        <app-upgrader-items-info
          [skins]="upgraderService.wonSkins()"
          [skinName]="upgraderService.wonSkins()[0]?.name"
          [label]="'items'"
          [variant]="'center'"
          [skipFirst]="true"
        />
      }
      <div class="upgrader__provably">
        <app-fairness-button [href]="'/provably-fair/upgrader/'"/>
        <div class="upgrader__seed">
          <span class="upgrader__seed-title">Hash:</span>
          @if (upgraderService.clientSeed()) {
            <span
              @fadeInAnimation
              class="upgrader__seed-value"
              (click)="clipboardService.copy(upgraderService.clientSeed()!, 'Client Seed copied!')"
            >
              {{ upgraderService.clientSeed() }}
            </span>
          }
        </div>
      </div>
    </div>

    <div class="upgrader__panel upgrader__panel--right">
      <app-upgrader-target-panel
        (upgrade)="onUpgrade()"
        (interacted)="onUserInteraction()"
      />
    </div>
  </div>

  <div class="upgrader__bottom">
    <div class="upgrader__tabs">
      <button
        class="upgrader__tab"
        [class.upgrader__tab--active]="activeBottomTab() === 'inventory'"
        (click)="activeBottomTab.set('inventory')"
      >
        Inventory
      </button>
      <button
        class="upgrader__tab"
        [class.upgrader__tab--active]="activeBottomTab() === 'targets'"
        (click)="activeBottomTab.set('targets')"
      >
        Upgrade Items
      </button>
    </div>
    <app-upgrader-inventory
      [class.upgrader__tab-content--active]="activeBottomTab() === 'inventory'"
      (interacted)="onUserInteraction()"
    />
    <app-upgrader-target-items
      [class.upgrader__tab-content--active]="activeBottomTab() === 'targets'"
      (interacted)="onUserInteraction()"
    />
  </div>
</div>
